import { AbilityBuilder, AbilityTuple, createMongoAbility, MongoAbility } from '@casl/ability'
import { createContext } from 'react'
import { UserInfoResponse } from 'src/types/user'

export enum Action {
  Manage = 'manage',
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}

export type Subjects = 'dashboard' | 'result-purchase' | 'users' | 'xero-callback' | 'all'

export type AppAbility = MongoAbility<AbilityTuple<Action, Subjects>>

export const defineAbilityFor = (): AppAbility => {
  const { build } = new AbilityBuilder<AppAbility>(createMongoAbility)

  return build()
}

export const updateAbility = (ability: AppAbility, user: UserInfoResponse) => {
  const { can, rules } = new AbilityBuilder<AppAbility>(createMongoAbility)

  if (user.role === 'user') {
    can(Action.Read, 'dashboard')
    can(Action.Read, 'result-purchase')
  }

  if (user.role === 'admin') {
    can(Action.Read, 'users')
  }

  can(Action.Read, 'xero-callback')

  ability.update(rules)
}

export const AbilityContext = createContext<AppAbility>(createMongoAbility())
